import moment from 'moment'
import { getDateFormat, getTimeFormat } from 'i18n/utils'

export const THINX_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss'
export const roundToMinutes = (time, minutes) =>
    time
        .clone()
        .startOf('minutes')
        .add(minutes - (time.minutes() % minutes), 'minutes')

export const getTimeSpan = (start = moment(), roundTo = 30, length = 60) => {
    const roundedStart = roundToMinutes(start, roundTo)
    const end = roundedStart.clone().add(length, 'minutes')

    return {
        start: roundedStart,
        end,
    }
}

export const formatToGrs = time => (time ? moment(time).format('YYYY/MM/DD HH:mm:s') : undefined)

// Format time with an hour and minute time part e.g. 2013-02-08 09:30
export const formatWithHoursMinutes = dateTime =>
    dateTime ? moment.parseZone(dateTime).format('YYYY-MM-DD HH:mm') : undefined

// Format time with only year, month and day e.g. 2020-09-12
export const formatToDate = dateTime => (dateTime ? moment.parseZone(dateTime).format('YYYY-MM-DD') : undefined)

// Format time with only hours and minutes e.g. 13:23
export const formatToTime = dateTime => (dateTime ? moment.parseZone(dateTime).format('HH:mm') : undefined)

export const formatToMultilineDateTime = momentString =>
    `${momentString.format(getDateFormat())}\n${momentString.format(getTimeFormat())}`
